package com.parmartechnologies.core.feature.product.network

import com.parmartechnologies.core.feature.product.model.ProductPrice
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class RetrieveProductRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("LastSyncDate") val lastSycDate: String,
)

@Serializable
data class  CreateProductRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("product_id") var productId: Long = Clock.System.now().epochSeconds,
    @SerialName("ProductType") var productType: String = "product",
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("category_id") var categoryID: String = "",
    @SerialName("sub_category_id") var subCategoryID: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("is_blacklisted") var isBlacklisted: Int = 0,
    @SerialName("name") var name: String = "",
    @SerialName("quantity") var qty: Long = 0,
    @SerialName("description") var description: String = "",
    @SerialName("manage_inventory") var manageInventory: Int = 0,
    @SerialName("product_price") var productPrice: ProductPrice? = ProductPrice(),
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("__v") var _v: Int = 0
)

@Serializable
data class UpdateProductRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("_id") var _id: String = "",
    @SerialName("product_id") var productId: Long = Clock.System.now().epochSeconds,
    @SerialName("ProductType") var productType: String = "product",
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("category_id") var categoryID: String = "",
    @SerialName("sub_category_id") var subCategoryID: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("is_blacklisted") var isBlacklisted: Int = 0,
    @SerialName("name") var name: String = "",
    @SerialName("quantity") var qty: Long = 0,
    @SerialName("description") var description: String = "",
    @SerialName("manage_inventory") var manageInventory: Int = 0,
    @SerialName("product_price") var productPrice: ProductPrice? = ProductPrice(),
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("__v") var _v: Int = 0
)

@Serializable
data class DeleteProductRequest(
    @SerialName("_id") var _id: String = ""
)

@Serializable
data class BacklistProductRequest(
    @SerialName("_id") var _id: String = "",
    @SerialName("is_blacklisted") var isBlacklisted: Int = 0,
)